import { render } from "./CalendarEventTimeSlotsPicker.vue?vue&type=template&id=6c1d0a36&scoped=true"
import script from "./CalendarEventTimeSlotsPicker.vue?vue&type=script&lang=ts"
export * from "./CalendarEventTimeSlotsPicker.vue?vue&type=script&lang=ts"

import "./CalendarEventTimeSlotsPicker.vue?vue&type=style&index=0&id=6c1d0a36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c1d0a36"

export default script